import { createContext, useContext } from "react";

export const BasenameContext = createContext("");

export const useBasename = (): string => useContext(BasenameContext);
